// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2jZH0","emails":"CreateEditClinics_emails__2FiaK","emailTagLabel":"CreateEditClinics_emailTagLabel__2SFLh"};